import { handleActions } from 'redux-actions';
import {
  key,
  timerStart,
  timerCancel,
  timerReset,
  timerEnd,
  timerDecrement,
  timerStartError,
  timerRefreshRequest
} from './actions';
import settings from 'Root/settings.json';

export const selectors = {
  value: state => state[key].value,
  status: state => state[key].status,
  percentage: state => state[key].percentage
};

export const timeout = settings.auto_logout;

const initialState = {
  value: timeout,
  percentage: 100,
  status: 'stopped'
};

export default handleActions({
  [timerStart]: (state, action) => ({
    ...state,
    status: 'started',
  }),
  [timerCancel]: (state, action) => ({
    ...state,
    status: 'stopped'
  }),
  [timerReset]: (state, action) => ({
    ...state,
    status: 'stopped',
    value: timeout,
    percentage: 100
  }),
  [timerEnd]: (state, action) => ({
    ...state,
    status: 'ended'
  }),
  [timerDecrement]: (state, action) => ({
    ...state,
    value: state.value - 1,
    percentage: (state.value - 1) / timeout * 100
  }),
  [timerStartError]: (state, action) => ({
    ...state,
    status: action.payload.message
  }),
  [timerRefreshRequest]: (state, action) => ({
    ...state,
    status: 'refresh'
  })
}, initialState);



// WEBPACK FOOTER //
// ./src/util/redux/autoLogout/reducer.js